import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "rounded-xl border-gray-100 shadow-xl p-6" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-4/5" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-green-700" }, [
    /*#__PURE__*/_createTextVNode(" Cantidad mensual de compras "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" por cancha ")
  ])
], -1)
const _hoisted_4 = { class: "flex items-center justify-end flex-1" }
const _hoisted_5 = { class: "pt-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "px-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "px-1" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-center my-4"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-center my-4"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "p-2" }, null, -1)
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "font-bold text-green-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UITextSelect = _resolveComponent("UITextSelect")
  const _component_UITextInput = _resolveComponent("UITextInput")
  const _component_UIButton = _resolveComponent("UIButton")
  const _component_Bar = _resolveComponent("Bar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_UITextSelect, {
            label: "Tipo Cancha",
            items: $setup.tipoCanchas,
            onSelected: _cache[1] || (_cache[1] = (id) => ($setup.tipoCancha = id))
          }, null, 8, ["items"])
        ]),
        _hoisted_6,
        _createVNode(_component_UITextInput, {
          class: "my-0",
          placeholder: "MM-YYYY",
          value: $setup.date,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ($setup.date = $event))
        }, null, 8, ["value"]),
        _hoisted_7,
        _createVNode(_component_UIButton, {
          class: "my-0",
          label: ">",
          onClick: $setup.requestStats
        }, null, 8, ["onClick"])
      ])
    ]),
    ($setup.isLoading)
      ? (_openBlock(), _createBlock("p", _hoisted_8, "...cargando stats"))
      : ($setup.hasSelection && !$setup.hasStatsData)
        ? (_openBlock(), _createBlock("p", _hoisted_9, "Sin datos"))
        : ($setup.hasSelection && $setup.hasStatsData)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_Bar, {
                "chart-data": $setup.chartData,
                height: 250,
                "chart-options": { locale: 'es-ES', plugins: { legend: { display: false } } }
              }, null, 8, ["chart-data"]),
              _hoisted_11,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.items, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.text + item.value
                }, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("p", _hoisted_13, _toDisplayString(item.text), 1),
                    _createVNode("p", null, _toDisplayString(item.value.toLocaleString('es-CL')), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
  ]))
}